import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ArrowDown } from '../icons';

class Accordion extends Component {
  constructor (props) {
    super(props);

    this.state = {
      isOpened: null
    };

    this.timeout = undefined;
    this.container = undefined;
    this.content = undefined;

    this.toggleOpenClose = this.toggleOpenClose.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onRest = this.onRest.bind(this);
    this.onWork = this.onWork.bind(this);
    this.onRefContainer = this.onRefContainer.bind(this);
    this.onRefContent = this.onRefContent.bind(this);
  }

  componentDidMount () {
    this.onResize();
  }

  componentDidUpdate (prevProps, prevState) {
    if (!this.state.isOpened && prevState.isOpened) {
      if ('auto' === this.container.style.height) {
        const { clientHeight: contentHeight } = this.content;
        this.container.style.height = `${contentHeight}px`;
      }
    }
    this.onResize();
  }

  shouldComponentUpdate (nextProps, nextState) {
    const { isOpened } = this.state;

    return this.props.children !== nextProps.children
      || isOpened !== nextState.isOpened;
  }

  toggleOpenClose () {
    this.setState({
      isOpened: !this.state.isOpened
    }, () => {
      if ('function' === typeof(this.props.onOpenCallback) && this.state.isOpened) {
        this.props.onOpenCallback();
      }
    });
  }

  onResize () {
    global.clearTimeout(this.timeout);

    if (!this.container || !this.content) {
      return;
    }

    const { isOpened } = this.state;
    const { clientHeight: containerHeight } = this.container;
    const { clientHeight: contentHeight } = this.content;

    const isFullyOpened = isOpened && contentHeight === containerHeight;
    const isFullyClosed = !isOpened && 0 === containerHeight;

    if (isFullyOpened || isFullyClosed) {
      this.onRest({ isOpened, contentHeight });
    } else {
      this.onWork({ isOpened, contentHeight });
      this.timeout = setTimeout(() => this.onResize(), 50);
    }
  }

  onRest ({ isOpened, contentHeight }) {
    if (!this.container || !this.content) {
      return;
    }

    const hasOpened = isOpened && this.container.style.height === `${contentHeight}px`;
    const hasClosed = !isOpened && '0px' === this.container.style.height;

    if (hasOpened || hasClosed) {
      this.container.style.overflow = isOpened ? 'initial' : 'hidden';
      this.container.style.height = isOpened ? 'auto' : '0px';
    }
  }

  onWork ({ isOpened, contentHeight }) {
    if (!this.container || !this.content) {
      return;
    }

    const isOpenining = isOpened && this.container.style.height === `${contentHeight}px`;
    const isClosing = !isOpened && '0px' === this.container.style.height;

    if (isOpenining || isClosing) {
      return;
    }

    this.container.style.overflow = 'hidden';
    this.container.style.height = isOpened ? `${contentHeight}px` : '0px';
  }

  onRefContainer (container) {
    this.container = container;
  }

  onRefContent (content) {
    this.content = content;
  }

  render () {
    const { header, children } = this.props;

    const arrowClass = null === this.state.isOpened ?
      '' : this.state.isOpened ?
        'accordion-arrow-up' : 'accordion-arrow-down';

    return (
      <div className="AccordionContainer flex column">
        <button
          className="AccordionButton flex middle space-between flex-basis-100 btn no-gutter remove-click-styling"
          onClick={this.toggleOpenClose}
        >
          {header}
          <ArrowDown
            width={24}
            height={24}
            className={`${arrowClass}`}
          />
        </button>
        <div
          ref={this.onRefContainer}
          style={{
            transition: 'height 250ms linear 0s'
          }}
        >
          <div
            className="AccordionChildren flex column"
            ref={this.onRefContent}
          >
            {children}
          </div>
        </div>
      </div>
    );
  }
}

Accordion.propTypes = {
  header: PropTypes.object,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  onOpenCallback: PropTypes.func
};

export default Accordion;
